import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    const groupTypesElement = document.getElementById('group-types-for-program-types-data');
    const groupTypesJson = groupTypesElement.getAttribute('data-group-types-for-program-types');
    const groupTypes = JSON.parse(groupTypesJson);
    this.groupTypes = groupTypes;
  }

  updateGroupTypeOptions(event) {
    const selectedProgramTypes = Array.from(event.target.selectedOptions).map(option => option.value)
    const allGroupTypeOptions = new Set()

    selectedProgramTypes.forEach(programType => {
      const options = this.groupTypes[programType] || []
      options.forEach(option => allGroupTypeOptions.add(option))
    })

    const groupTypeTarget = document.getElementById('group-type-select');

    const optionsHtml = ['<option value=""></option>'].concat(
      Array.from(allGroupTypeOptions).map(option => {
        const humanizedOption = option.toString().replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
        return `<option value="${option}">${humanizedOption}</option>`
      })
    )

    groupTypeTarget.innerHTML = optionsHtml.join("")
  }
}
